import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=40033b62"
import script from "../../controllers/course/course-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/course/course-list.js?vue&type=script&lang=js&external"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=40033b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports